module.exports = __webpack_public_path__ + "img/5.ea3da536.jpg";